export function validatePRxThreshold(value: number | null) {
    if (value === null || value < -1 || value > 1) {
        return "PRx threshold must be a number between -1 and 1, typically set to 0.2"
    }

    return undefined
}
